import { render, staticRenderFns } from "./category-move.vue?vue&type=template&id=0a7e934a&scoped=true&"
import script from "./category-move.vue?vue&type=script&lang=js&"
export * from "./category-move.vue?vue&type=script&lang=js&"
import style0 from "./category-move.vue?vue&type=style&index=0&id=0a7e934a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e934a",
  null
  
)

export default component.exports